import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastCtrl:ToastController) { }
  async error(text:string,button:boolean=false) {
    const toast = await this.toastCtrl.create({
      message: text,
      position: "top",
      translucent:true,
      duration:3000,
      color: 'danger'
    });
    return toast.present();
  }
  async errorWithButton(text:string,callback:Function) {
    const toast = await this.toastCtrl.create({
      message: text,
      position: "top",
      translucent:true,
      buttons:[{text:'Повторить',role:'cancel'}],
      color: 'danger'
    });
    toast.onDidDismiss().then(()=>{
      callback();
    });
    return toast.present();
  }
  async logWithButton(text:string,buttonText:string,callback:Function,duration:number=30000) {
    const toast = await this.toastCtrl.create({
      message: text,
      position: "bottom",
      cssClass:'custom-toast-wb',
      buttons:[{text:buttonText,role:'cancel',handler:()=>callback()}],
      duration:duration
    });
    return  toast.present();
  }
  async log(text:string,duration=4000) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration: duration,
      position: "bottom",
      cssClass:'custom-toast'
    });
    return  toast.present();
  }
}
